module.exports = __webpack_public_path__ + "static/img/detect10.af15943.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/detect10.png
// module id = 584
// module chunks = 4